// musical & tiktok
// 客户端有问题，这里临时将id改为in.
// https://wiki.bytedance.net/pages/viewpage.action?pageId=224481401
// https://wiki.bytedance.net/pages/viewpage.action?pageId=237412301
// 20190403 客户端和平台前后端同时修正，将印尼语语言码in改id
// 20190403 https://wiki.bytedance.net/pages/viewpage.action?pageId=332691546
// 20190417 https://bytedance.feishu.cn/space/sheet/shtcnpaQYHtm3mkep8qdCr#696cd7
export const TopbuzzLanguages = ['en', 'ja', 'pt', 'zh-Hant', 'ko'];
export const tiktokLanguages = ['ja', 'zh-Hant', 'en', 'ko', 'th', 'ms', 'id', 'vi', 'ru', 'tr'];
export const tiktokAdNetworkLanguages = ['en', 'ja', 'pt', 'de', 'fr', 'it', 'es', 'ru',
  'zh-Hant', 'ko', 'id', 'th', 'ms', 'vi', 'tr', 'ar'];
export const HeloLanguages = ['hi', 'te', 'ta', 'ml', 'mr', 'gu', 'or', 'bn', 'kn', 'pa', 'as', 'bgc', 'raj', 'bh'];
export const allLanguages = ['ja', 'zh-Hant', 'en', 'ko', 'ar', 'es', 'id', 'th', 'ms', 'de', 'vi', 'fr', 'it', 'ru',
  'tr', 'pt', 'hi', 'te', 'ta', 'ml', 'mr', 'gu', 'or', 'bn', 'kn', 'pa', 'as', 'bgc', 'raj', 'bh'];
/**
 * @file 语言相关
 */
// topbuzz short语言列表，key 为i18n翻译path，val 为对应值
export const EnumLanguage = {
  english: 'en',
  japanese: 'ja',
  portuguese: 'pt',
  german: 'de',
  french: 'fr',
  italian: 'it',
  spanish: 'es',
  russian: 'ru',
};

// 给 /official/article 页面使用的（平台不支持）的语言，不会设置cookie，会有 artical_temp_lang 的url query 特殊记录
export const articleTempLangs = {
  pt: 'Português', // 葡萄牙语
};
